import { baseUrl } from './util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';

interface SolarRecommadParams {
    productId: string;
    variantId: string;
}
export const getSolarRecommand = (params: SolarRecommadParams, locale?: string) => {
    return request.get(`${baseUrl(locale)}/ProductCaculation/productInfo${setLocaleQuery(locale)}`, {
        params,
    });
};

export const getSolarRecommand2 = (params: any, locale?: string) => {
    return request.post(`${baseUrl(locale)}/ProductCaculation/productInfoList`, {
        data: params,
    });
};
